// extracted by mini-css-extract-plugin
export default {"inputParentBaseStyle":"styles_inputParentBaseStyle__x3+fQ","addItemBox":"styles_addItemBox__4xczx","inputError":"styles_inputError__qg4RP","errorBorder":"styles_errorBorder__XYUFF"};